<template>
    <div id="facebook-sidebar" class="sidebar" v-bind:class="{ closeSidebar: !collapseSidebar }">
        <topsidebar></topsidebar>
        <newcontactsidebar></newcontactsidebar>
    </div>
</template>
<script>

// Components
import FbTopSidebar        from './FbTopSidebar.vue';
import NewContactsSidebar  from '@/core/components/contacts/NewContactsSidebar.vue';

export default {
    components: {
        'topsidebar':        FbTopSidebar,
        'newcontactsidebar': NewContactsSidebar
    },
    props: ['collapseSidebar']
};
</script>
